module.exports = __webpack_public_path__ + "static/img/17069D_1_C_20210325_fit.b6f90df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17069D_1_C_20210325_fit.png
// module id = wU4Y
// module chunks = 0